import { useState, useCallback } from 'react';

const STORAGE_KEY = 'glowytics_dashboard_v10_prefs';

function getStoredPrefs() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch { return {}; }
}

function savePrefs(prefs) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs)); } catch {}
}

export function useDashboardPrefs() {
  const [prefs, setPrefs] = useState(getStoredPrefs);

  const pinnedMetrics = prefs.pinnedMetrics || [];
  const collapsedSections = prefs.collapsedSections || {};

  const togglePin = useCallback((metricKey) => {
    setPrefs(prev => {
      const pins = prev.pinnedMetrics || [];
      const next = pins.includes(metricKey) ? pins.filter(k => k !== metricKey) : [...pins, metricKey];
      const updated = { ...prev, pinnedMetrics: next };
      savePrefs(updated);
      return updated;
    });
  }, []);

  const toggleSection = useCallback((sectionKey) => {
    setPrefs(prev => {
      const sections = { ...(prev.collapsedSections || {}) };
      sections[sectionKey] = !sections[sectionKey];
      const updated = { ...prev, collapsedSections: sections };
      savePrefs(updated);
      return updated;
    });
  }, []);

  const isSectionCollapsed = useCallback((sectionKey) => {
    return !!collapsedSections[sectionKey];
  }, [collapsedSections]);

  return { pinnedMetrics, togglePin, collapsedSections, toggleSection, isSectionCollapsed };
}
